export const handleElementWidth = (elementId: string, width: string) => {
  const divToChangeWidth = document.getElementById(elementId) as HTMLDivElement;

  divToChangeWidth.style.width = width;
};
